var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkiing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4249 32.199C71.1451 33.9559 67.8716 33.5338 66.113 31.2567C64.3545 28.9795 64.7766 25.7092 67.0565 23.9523C69.3364 22.1954 72.6099 22.6175 74.369 24.8947C76.1275 27.1718 75.7054 30.4422 73.425 32.199H73.4249Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8264 64.9025L67.8901 79.4674C69.7868 80.1572 71.8513 79.1911 72.5422 77.2949L72.8633 76.407L75.135 77.2334L74.8139 78.1261C73.6761 81.2496 70.1882 82.8748 67.0642 81.7391L27.0005 67.1741L27.8264 64.9025Z",
    fill: "#592EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3562 32.2514C62.8943 32.2514 63.4352 32.3674 63.9619 32.5585C66.2914 33.5549 67.3736 36.251 66.3751 38.5799L65.2557 41.6402L74.4081 44.9699C75.663 45.426 76.3102 46.8137 75.8536 48.0681L75.7256 48.413C75.2685 49.6679 73.8824 50.3145 72.6275 49.8578C61.601 45.8131 39.2652 37.7298 39.2652 37.7298L38.6893 39.3118L36.4176 38.4855L36.9941 36.9035L33.164 35.5104L33.9904 33.2387L37.8252 34.6318L38.4017 33.0546L40.6734 33.881L40.097 35.4581L53.6321 40.3795L58.1568 34.2966C59.1591 32.9478 60.7362 32.2121 62.3507 32.2515L62.3562 32.2514Z",
    fill: "#592EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6422 44.4165L58.638 47.3258L54.5197 52.5068L58.8835 55.5293C61.6734 57.4627 62.4534 61.2463 60.6544 64.1248L53.5282 75.5301L47.5397 73.3527L54.1752 63.7561C54.8272 62.8126 54.5827 61.5215 53.6317 60.8799L48.4323 57.3709C45.7401 55.5546 45.1113 51.859 47.0484 49.2526L50.6422 44.4165Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiing);
export default __webpack_public_path__ + "static/media/Skiing.3879eebb323f9dd467c84a88b575fe18.svg";
export { ForwardRef as ReactComponent };